import React from 'react'

import Layout from '../components/Default/Layout'

import EKPNumbers from '../components/Homepage/EKPNumbers'
import OurTeam from '../components/Homepage/OurTeam'
import NewsAndBlog from '../components/Homepage/NewsAndBlog'
import Newsletter from '../components/Homepage/Newsletter'
import References from '../components/Homepage/References'
import WriteUs from '../components/Homepage/WriteUs'
import LandingPhoto from '../components/Homepage/LandingPhoto'

const Index = () => {
  return (
    <Layout>
      <LandingPhoto />
      <EKPNumbers />
      {/* TODO: Remove styled components -> Write pure css */}
      <OurTeam />
      <NewsAndBlog />
      <Newsletter />
      <References />
      <WriteUs />
    </Layout>
  )
}

export default Index
